import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack, Grid } from '@mui/material';
import useEventContext from '@/contexts/event/useEventContext';
import {
  formatUTCDate,
  formatDateRange,
  formatLocalDate,
} from '@/locales/dates';

import Image from '@/components/Image';
import ResumeInfo from '@/components/ResumeInfo';
import useMobile from '../../../../hooks/useMobile';

const GOOGLE_MAPS_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;

function EventSummary({ onReadMore = () => {} }) {
  const [endEventDateTime, setEndEventDateTime] = useState(null);
  const [startEventDateTime, setStartEventDateTime] = useState(null);
  const [calendarStartDate, setCalendarStartDate] = useState(null);
  const [calendarEndDate, setCalendarEndDate] = useState(null);
  const {
    event: {
      event: { name, banner, start_date, end_date },
      location: { venue, latitude, longitude, city, state } = {
        venue: '',
        address: '',
      },
    },
  } = useEventContext();
  const { isMobile } = useMobile();

  useEffect(() => {
    setStartEventDateTime(formatLocalDate(start_date));
    setEndEventDateTime(formatDateRange(start_date, end_date));

    setCalendarStartDate(formatUTCDate(start_date, 'YYYYMMDDTHHmmss'));

    setCalendarEndDate(formatUTCDate(end_date, 'YYYYMMDDTHHmmss'));
  }, []);

  return (
    <>
      {isMobile ? (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '20px',
            overflow: 'hidden',
          }}
        >
          <Image
            sx={{ borderRadius: '16px', width: '343px', height: '125px' }}
            src={banner}
          />
        </Box>
      ) : (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '16px',
            overflow: 'hidden',
          }}
        >
          <Image src={banner} ratio="480/180" />
        </Box>
      )}
      <Box
        sx={{
          width: '100%',
          mt: 2,
        }}
      >
        <Stack alignItems="center" direction="row">
          <Typography variant="h5" component="div">
            {name}
          </Typography>
          <Box sx={{ flex: 1 }}></Box>
        </Stack>
      </Box>
      <Box
        sx={{
          width: '100%',
        }}
      >
        <Grid container spacing={1} sx={{ height: '100%', marginTop: '0px' }}>
          <Grid item md={6}>
            <ResumeInfo
              title={startEventDateTime}
              subtitle={endEventDateTime}
              iconify="ic:baseline-calendar-today"
              url={`http://www.google.com/calendar/render?action=TEMPLATE&text=${name}&dates=${calendarStartDate}/${calendarEndDate}&location=${venue}`}
              sx={{
                '& h6': {
                  textTransform: 'capitalize',
                },
              }}
            />
          </Grid>
          <Grid item md={6}>
            {venue !== 'Online' && (
              <ResumeInfo
                title={venue}
                subtitle={`${city}, ${state}`}
                url={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_KEY}&q=${latitude},${longitude}`}
                iconify="ic:baseline-place"
              />
            )}
            {venue === 'Online' && (
              <ResumeInfo
                title={venue}
                url={`http://www.google.com/calendar/render?action=TEMPLATE&text=${name}&dates=${calendarStartDate}/${calendarEndDate}&location=${venue}`}
                iconify="ic:baseline-place"
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default EventSummary;
